module.exports = __webpack_public_path__ + "img/many-articles.0fbd3e1e.png";